module.exports = __webpack_public_path__ + "static/images/arrow-move-right.2bM8ZRH.svg";